import styles from "@/components/directory/v2/card-view/EVsCardItemComponent.module.css";
import EVsCardItemModelComponent from "@/components/directory/v2/card-view/EVsCardItemModelComponent";

const EVsCardItemComponent = ({ evModel, onClick, isSelected }) => {
  return (
    <div className={`${styles.container} ${isSelected ? styles.selected : ''}`} onClick={onClick}>
      <EVsCardItemModelComponent model_object={evModel} showVariants={isSelected} />
    </div>
  );
};

export default EVsCardItemComponent;
